import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle as faExclamationTriangleLight
} from '@fortawesome/pro-light-svg-icons';

import {
  faCheckCircle as faCheckCircleReg,
  faFilePdf as faFilePdfReg
} from '@fortawesome/pro-regular-svg-icons';

import {
  faArrowLeftLong as faArrowLeftLongSolid,
  faUpLong as faUpLongSolid,
  faDownLong as faDownLongSolid,
  faShareFromSquare as faShareFromSquareSolid,
  faChevronDown as faChevronDownSolid,
  faCaretUp as faCaretUpSolid
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faExclamationTriangleLight,
  faCheckCircleReg,
  faFilePdfReg,
  faArrowLeftLongSolid,
  faUpLongSolid,
  faDownLongSolid,
  faShareFromSquareSolid,
  faChevronDownSolid,
  faCaretUpSolid
);
